import { render, staticRenderFns } from "./bondtick.vue?vue&type=template&id=a8cd87c6&scoped=true&"
import script from "./bondtick.vue?vue&type=script&lang=js&"
export * from "./bondtick.vue?vue&type=script&lang=js&"
import style0 from "./bondtick.vue?vue&type=style&index=0&id=a8cd87c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cd87c6",
  null
  
)

export default component.exports